import { Phone, Mail, MapPin } from 'lucide-react';
import { FaWhatsapp, FaInstagram, FaYoutube } from 'react-icons/fa';
import { buildWaLink } from '@/config/brand';
import { useContent } from '@/lib/content';
import { Reveal, SectionHeading } from '@/components/Reveal';
import { trackEvent } from '@/lib/analytics';

export const Contact = () => {
  const { brand } = useContent();
  const ROWS = [
  { icon: Phone, label: 'Call Us', value: brand.phoneDisplay, href: `tel:${brand.phone}`, testid: 'contact-phone', event: 'phone_click' },
  { icon: FaWhatsapp, label: 'WhatsApp', value: brand.phoneDisplay, href: buildWaLink(brand.whatsapp), testid: 'contact-whatsapp', event: 'whatsapp_click' },
  { icon: Mail, label: 'Email', value: brand.email, href: `mailto:${brand.email}`, testid: 'contact-email', event: 'email_click' },
  { icon: MapPin, label: 'Location', value: `${brand.city}, India`, href: 'https://www.google.com/maps/search/?api=1&query=Hyderabad,Telangana', testid: 'contact-location', event: 'location_click' },
  ];
  return (
  <section id="contact" data-testid="contact-section" className="py-24 sm:py-32 bg-surface border-t border-white/5">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <SectionHeading chapter="10" label="Contact" title={<>Let&rsquo;s Create Something <span className="italic text-champagne">Unforgettable.</span></>} />

      <div className="mt-16 grid lg:grid-cols-2 gap-12 lg:gap-20">
        <div>
          {ROWS.map((r, i) => (
            <Reveal key={r.label} delay={i * 0.08}>
              <a
                data-testid={r.testid}
                href={r.href}
                target={r.href.startsWith('http') ? '_blank' : undefined}
                rel="noopener noreferrer"
                onClick={() => trackEvent(r.event, { location: 'contact' })}
                className="group flex items-center gap-6 py-6 border-b border-white/10 hover:border-champagne/40 transition-colors duration-300"
              >
                <span className="w-12 h-12 border border-white/15 flex items-center justify-center text-champagne group-hover:border-champagne transition-colors duration-300">
                  <r.icon size={18} />
                </span>
                <div>
                  <p className="text-[10px] uppercase tracking-[0.3em] text-white/40">{r.label}</p>
                  <p className="mt-1 font-serif text-xl text-cream group-hover:text-champagne transition-colors duration-300">{r.value}</p>
                </div>
              </a>
            </Reveal>
          ))}
          <Reveal delay={0.35} className="mt-10 flex gap-4">
            <a data-testid="contact-instagram" href={brand.instagram} target="_blank" rel="noopener noreferrer" aria-label="Instagram"
              className="w-12 h-12 border border-white/15 flex items-center justify-center text-white/60 hover:text-champagne hover:border-champagne transition-colors duration-300">
              <FaInstagram size={18} />
            </a>
            <a data-testid="contact-youtube" href={brand.youtube} target="_blank" rel="noopener noreferrer" aria-label="YouTube"
              className="w-12 h-12 border border-white/15 flex items-center justify-center text-white/60 hover:text-champagne hover:border-champagne transition-colors duration-300">
              <FaYoutube size={18} />
            </a>
          </Reveal>
        </div>

        <Reveal delay={0.2} className="min-h-[360px]">
          <iframe
            data-testid="contact-map"
            title="Events by AJ — Hyderabad, Telangana"
            src="https://www.google.com/maps?q=Hyderabad%2C%20Telangana&output=embed"
            className="w-full h-full min-h-[360px] border border-white/10 grayscale invert-[0.9] contrast-[0.9]"
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </Reveal>
      </div>
    </div>
  </section>
  );
};
